import { type ComponentProps, forwardRef, type PropsWithChildren } from "react";

import { cn } from "$/lib/utils/functions/misc.functions";

/*
NOTE:
A global css property is used to style the radio button
`background` (and not `background-color`) upon being checked.
This is due to Tailwind not having a class specific for the `background` property.

Also for an unknown reason, a custom class cannot override the `background` property
so we had to use element selectors to style the background
*/
const RadioButton = forwardRef<
  HTMLInputElement,
  PropsWithChildren<ComponentProps<"input">>
>(({ className, ...radioButtonProps }, forwardedRef) => {
  return (
    <input
      ref={forwardedRef}
      type="radio"
      className={cn(
        "bg-snow size-[22px] rounded-full border-none text-primary outline-none transition-all duration-200 focus:ring-0 focus:ring-offset-0 disabled:pointer-events-none disabled:opacity-50",
        "relative appearance-none",
        "after:absolute after:left-1/2 after:top-1/2 after:-translate-x-1/2 after:-translate-y-1/2 after:opacity-0 after:transition-opacity after:content-['']",
        "after:h-[10px] after:w-[5px] after:rotate-45 after:border-b-2 after:border-r-2 after:border-white",
        "checked:after:opacity-100",
        className,
      )}
      {...radioButtonProps}
    />
  );
});

RadioButton.displayName = "RadioButton";

export default RadioButton;
